import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from "redux-form";
import { Icon } from "rhombus-react";
import Sparkler from "./Sparkler";

import { getVersionGenSelectedPreview } from "utils/Flags";
import { useVariableBounds } from "./utils";
import { AI_GENERATE_VERSIONS_FORM } from "./constants";
import { clearRefinements } from "reducers/Refinements";
import { generateAssets } from 'reducers/VersionGeneration';
import TextVariableList from './TextVariableList';
import ImageVariableList from './ImageVariableList';

import "./AssetsPanel.css";

export default function AssetsPanel(props){
	const { libraryId } = props;
	const dispatch = useDispatch();

	const { generatedAssets, isGeneratingAssets } = useSelector(state => state.versionGeneration);
	const { texts = [], images = []} = generatedAssets || {};
	const { getTextWithBounds, getImageWithDimensions } = useVariableBounds()
		, isAIDevEnabled = getVersionGenSelectedPreview()
		;
	const formValues = useSelector(getFormValues(AI_GENERATE_VERSIONS_FORM))
		;

	const brandKits = formValues["brand-kits"];
	const {
		prompt,
		audiences,
		products,
	} = formValues;

	function regenerate(){
		const data = {
			// ...generatedAssets,
			prompt,
			// Conditionally add metadata to request body
			brandKits: brandKits ? [{ id: brandKits }] : [],
			audiences: audiences ? [{ id: audiences }] : [],
			products: products ? [{ id: products }] : [],
			texts: texts.map(getTextWithBounds),
			images: images.map(getImageWithDimensions),
		};
		dispatch(clearRefinements());
		dispatch(generateAssets(libraryId, data));
	}

	const variableListing = useMemo(() => {
		const generatedTexts = texts.map((generatedVariable) => {
			return (
				<TextVariableList
					key={generatedVariable.name}
					libraryId={libraryId}
					variableName={generatedVariable.name}
					variableOptions={generatedVariable.values}
				/>
			);
		});
		const generatedImages = images.map((generatedVariable) => {
			return (
				<ImageVariableList
					key={generatedVariable.name}
					libraryId={libraryId}
					variableName={generatedVariable.name}
					variableOptions={generatedVariable.values}
				/>
			);
		});

		if(isAIDevEnabled){
			return [
				...generatedImages,
				...generatedTexts,
			];
		}

		return [
			...generatedTexts,
			...generatedImages,
		];
	}, [texts, images, isAIDevEnabled]);

	if(isGeneratingAssets){
		return (
			<div className="panel assets-panel generating">
				<div className="panel-title">
					Assets
				</div>
				<div className="generating-status">
					<Sparkler />
					Generating Assets ...
				</div>
			</div>
		);
	}
	return (
		<div className="panel assets-panel">
			<div className="panel-title">
				Assets
				<Icon
					name="refresh"
					className="cypress-gen-ai-assets-refresh"
					onClick={regenerate}
					data-tip="Regenerate all assets"
				/>
			</div>
			<div className="panel-body">
				{variableListing}
			</div>
		</div>
	);
}

AssetsPanel.displayName = "AssetsPanel";
